module.exports = "/_next/static/images/c23fb744a6d59435be3ede35e4255588-mulher-com-cachos-maravilhosos-segurando-cartao-lg@1x.jpg.webp";